import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { CompanyProfileService } from '../services/CompanyProfileService';
import { ExternalLenderStore } from './externalLenderStore';

export class LicenseGridStore extends GridStore {
  private globalStore: GlobalStore;
  private salesforceLenderStore: ExternalLenderStore;
  private companyProfileService: CompanyProfileService;

  constructor(globalStore: GlobalStore, salesforceLenderStore: ExternalLenderStore) {
    super(() => this.fetchRows());
    this.globalStore = globalStore;
    this.salesforceLenderStore = salesforceLenderStore;
    this.companyProfileService = new CompanyProfileService();
  }

  fetchRows = async (): Promise<ApiResponse> => {
    const lenderId = this.salesforceLenderStore.salesForceLender?.lenderId;
    const { pageNumber, pageSize, sortBy, sortDir, filters } = this.gridData.meta;
    return this.companyProfileService.getLicensesGrid(
      lenderId,
      pageNumber,
      pageSize,
      sortBy,
      sortDir,
      filters ? JSON.stringify(filters) : null
    );
  };
}
